// extracted by mini-css-extract-plugin
export default {"root":"K53l_Tg5"};